const React = require("react");
function IconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.83006 21h3.50324v-9h2.353L16 8.90797h-2.6667V7.36196c0-.82822.0523-1.26995 1.1504-1.26995h1.464V3h-2.3529c-2.8236 0-3.81703 1.49079-3.81703 4.03067v1.8773H8V12h1.77777v9z"
  }));
}
module.exports = IconFacebook;